export let section = [
    {
        id: 0,
        title: "Service Type",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 1,
        title: "Service Acknowledgment Form Type",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 2,
        title: "Home Address",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 3,
        title: "Services Provided",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 4,
        title: "Home Assessment",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 5,
        title: "Partner Reporting Fields",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 6,
        title: "Region Designated Reporting Fields",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 7,
        title: "Information for Future Follow Up",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    },
    {
        id: 8,
        title: "Administrative Section",
        active: true,
        buttonColor: "is-rounded is-danger is-light",
        isSectionValidaded: false,
        buttonIcon: "<i class='fas fa-ellipsis-h'></i>"
    }
];